import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { ActivatedRoute, Router } from '@angular/router';

import { ToastrService } from 'ngx-toastr';
import { EncryptionService } from 'src/app/service/encryption/encryption.service';
import { HttpService } from 'src/app/service/http/http.service';
import { LoaderService } from 'src/app/service/loader/loader.service';
import { SharedService } from 'src/app/service/shared/shared.service';
import { AddAuthorityComponent } from '../add-authority/add-authority.component';
import { AddAssetComponent } from '../add-asset/add-asset.component';
import { MatTreeFlatDataSource, MatTreeFlattener } from '@angular/material/tree';
import { FlatTreeControl } from '@angular/cdk/tree';
import { UserAssetComponent } from '../user-asset/user-asset.component';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { AssetEmployeeEditComponent } from '../asset-employee-edit/asset-employee-edit.component';
import { Config } from 'src/app/app-constant';
import { ToastController } from '@ionic/angular';
import { DatePipe } from '@angular/common';
import { ConfirmationPopupComponent } from 'src/app/shared/popups/confirmation-popup/confirmation-popup.component';
// import { linkHorizontal } from 'd3';
import { AllocateAssetComponent } from '../allocate-asset/allocate-asset.component';
import * as echarts from 'echarts';
import { NewAssetEmployeeComponent } from '../new-asset-employee/new-asset-employee.component';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { calculateFiscalYear, formatYearRanges } from 'src/app/shared/commen-function-file';

export interface InnerTable {
  key: string;
  value: string;
}

export interface Item {
  name: string;
  details: string;
  additionalInfo1: string;
  additionalInfo2: string;
  innerTable: InnerTable[];
}
export const MY_DATE_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
}
@Component({
  selector: 'app-assest-management',
  templateUrl: './assest-management.component.html',
  styleUrls: ['./assest-management.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*', minHeight: "*" })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'en-GB' }, // Use en-GB to get DD/MM/YYYY format
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS },
  ],
})
export class AssestManagementComponent implements OnInit {
  selectedTypeTabName: any = 'Dashboard';
  selectedTypeTabIndex: any;
  buttonColorName: any;
  subModuleButtonColor: any | null;
  loggedInUserCompanyID: any;
  loggedInCompanyFiscalyear: any | null;
  loggedInUserEmpCode: any | null;
  loggedInUserId: any | null;
  loggedInCompanyMDCode: any | null;
  loggedInUserRole: any;
  loggedInCompanyReviewCycle: any | null;
  loggedInUserRoles: any;
  loggedInUserName: any | null;
  loggedInUserRoleIsEmployee: boolean = false;
  originalData: any;
  showSetupPopup: boolean = false;
  competencyListManagerView: any;
  showImportPopup: boolean = false;
  selectedManagerDashboardId: boolean = false;
  selectedEmployeeDashboardId: any;
  selectedYearForCompetency: any = null;
  pmsYears: any = [];


  comparisonEmpIdsForSecondLast: any = [];

  selectedEmpYearonYear: any = [];
  selectedYearForGraphTwoHRAdmin: any = null;
  selectedYearForGraphFifthHRAdmin: any = null;
  selectedYearForGraphSix: any = null;
  selectedYearForGraphNineHRAdmin: any = null;
  selectedYearForGraphTenHRAdmin: any = null;
  weightageWiseCompetenciesGraphData: any[] = [];
  graphDataForLineGraph: any[] = [];
  selectedYearForGraphOneHRAdmin: any = null;
  fromYear: any = null;
  toYear: any = null;
  constructor(private datePipe: DatePipe, public sharedService: SharedService,
    private loader: LoaderService, private encryptionService: EncryptionService,
    private httpService: HttpService, private config: Config, public router: Router,
    private fb: FormBuilder, public dialog: MatDialog,
    private activatedroute: ActivatedRoute, private toastr: ToastrService,
    private toastController: ToastController,
    private cdRef: ChangeDetectorRef,
    public dialogRef: MatDialogRef<AssestManagementComponent>,
  ) {
    this.groupAssetsByName();
  }
  ngOnInit() {


    this.cdRef.detectChanges();



    this.buttonColorName = sessionStorage.getItem('buttonColorName');
    this.subModuleButtonColor = sessionStorage.getItem('subModuleButtonColor');
    this.loggedInUserCompanyID = Number(this.encryptionService.decryptData(sessionStorage.getItem('loggedInUserCompanyID')));
    this.loggedInCompanyFiscalyear = sessionStorage.getItem('loggedInCompanyFiscalyear');
    this.loggedInUserEmpCode = sessionStorage.getItem('empCode');
    if (this.loggedInCompanyFiscalyear) {
      this.loggedInCompanyFiscalyear = this.encryptionService.decryptData(this.loggedInCompanyFiscalyear);
    }
    this.loggedInUserId = sessionStorage.getItem('loggedInUserId');
    this.loggedInUserName = sessionStorage.getItem('loggedInUserName');
    this.loggedInUserRole = sessionStorage.getItem('loggedInUserRole');
    this.loggedInCompanyMDCode = sessionStorage.getItem('loggedInCompanyMDCode');
    if (this.loggedInUserRole) {
      this.loggedInUserRole = this.encryptionService.decryptData(this.loggedInUserRole);
    }
    this.loggedInUserRoles = JSON.parse(sessionStorage.getItem('loggedInUserRoles') || '[]');
    this.loggedInCompanyReviewCycle = sessionStorage.getItem('loggedInCompanyReviewCycle') || null;


    if (this.loggedInUserRoles.length == 1) {
      for (let i = 0; i < this.loggedInUserRoles?.length; i++) {
        if (this.loggedInUserRoles[i].displayName == "Employee") {
          this.loggedInUserRoleIsEmployee = true
        }
      }
    }


    // this.originalData = JSON.parse(JSON.stringify(this.competencyListManagerView));
    this.getpmsyearlist();

  }




  tabTypeChanged(event: MatTabChangeEvent) {

    this.selectedTypeTabName = event.tab.textLabel;
    this.selectedTypeTabIndex = event?.index;


  }

  onClickSetup(operation: any) {
    this.router.navigate(['/home/hrportal/asset-management', { operation: operation }]);

  }

  onClickback() {
    this.router.navigate(['/home/hrportal/asset-management']);

  }
  ionViewWillEnter() {
    this.activatedroute.params.subscribe((params: any) => {
      // debugger

      var tab = params['tab'];
      if (tab === 'My Competency') {
        this.selectedTypeTabName = 'My Competency'
        this.selectedTypeTabIndex = 1;

      };

      if (params?.operation === 'Setup') {
        if (this.loggedInUserRole === 'HR Admin' || this.loggedInUserRole === 'Super Admin'
          || this.loggedInUserRole === 'PHI Admin' || this.loggedInUserRole === 'MD') {
          this.showSetupPopup = true;

          // this.getPmsYears();
        }
      } else if (params?.operation === 'import') {
        if (this.loggedInUserRole === 'HR Admin' || this.loggedInUserRole === 'Super Admin'
          || this.loggedInUserRole === 'PHI Admin' || this.loggedInUserRole === 'MD') {
          this.showImportPopup = true;
        }
      } else {
        if (this.loggedInUserRole === 'HR Admin' || this.loggedInUserRole === 'Super Admin'
          || this.loggedInUserRole === 'PHI Admin' || this.loggedInUserRole === 'MD') {
          // this.getDepartmentsByCompany();
        }
        else if (this.loggedInUserRole === 'Finance') {
          this.selectedManagerDashboardId = true; // Set up a manager-specific action
          // Call a manager-specific method if needed
        }

        else {
          this.selectedEmployeeDashboardId = this.loggedInUserId;
          // this.getUserByID();
        }

      }
    });
  }
  // getpmsyearlist() {
  //   this.httpService.callGetService(this.config.getpmsyearlist + this.loggedInUserCompanyID).subscribe((data: any) => {
  //     this.pmsYears = [];
  //     this.pmsYears = [];

  //     data?.data?.yearRanges?.forEach((ele: any) => {
  //       const test = ele.split('_');
  //       const obj = {
  //         year: test[0] + '-' + test[1],
  //       };

  //       // Get the current year
  //       const currentYear = new Date().getFullYear();

  //       // Ensure only past and current years are included
  //       const yearParts = obj.year.split('-');
  //       const fromYear = parseInt(yearParts[0]);
  //       const toYear = parseInt(yearParts[1]);

  //       // Add to pmsYears only if it's not a future year
  //       if (toYear <= currentYear) {
  //         this.pmsYears.push(obj);
  //       }
  //     });

  //     // Iterate over the years and set the selected year for various fields
  //     this.pmsYears?.forEach((ele: any) => {
  //       const currentYear = new Date().getFullYear();
  //       let yearValue = '';

  //       // Determine the fiscal year based on the company fiscal year
  //       if (this.loggedInCompanyFiscalyear === 'Jan_Dec') {
  //         yearValue = `${currentYear}-${currentYear}`; // Calendar year
  //       } else if (this.loggedInCompanyFiscalyear === 'Apr_Mar') {
  //         if (new Date().getMonth() < 3) {
  //           // If it's Jan, Feb, or Mar, we're in the previous fiscal year
  //           yearValue = `${currentYear - 1}-${currentYear}`;
  //         } else {
  //           // From Apr onwards, it's the current fiscal year
  //           yearValue = `${currentYear}-${currentYear + 1}`;
  //         }
  //       }




  //       if (ele?.year == yearValue) {
  //        this.selectedYearForCompetency = ele?.year;
  //         this.selectedYearForGraphOneHRAdmin = ele?.year;
  //         this.selectedYearForGraphTwoHRAdmin = ele?.year;
  //         this.selectedYearForGraphFifthHRAdmin = ele?.year;
  //         this.selectedYearForGraphSix = ele?.year;
  //         this.selectedYearForGraphNineHRAdmin = ele?.year;
  //         this.selectedYearForGraphTenHRAdmin = ele?.year;

  //         var test = ele?.year?.split('-');
  //         this.fromYear = test[0];
  //         this.toYear = test[1];
  //       }
  //     });

  //     // Handle the selectedTypeTabName logic if needed
  //     if (this.selectedTypeTabName === 'My Competency') {
  //       // Add your logic here
  //     } else if (this.selectedTypeTabName === 'Competency Master') {
  //       // Add your logic here
  //     } else if (this.selectedTypeTabName === 'Team Competency') {
  //       // Add your logic here
  //     }

  //     // Call additional functions if needed
  //     if (this.loggedInUserRole === 'HR Admin' || this.loggedInUserRole === 'Super Admin'
  //       || this.loggedInUserRole === 'PHI Admin' || this.loggedInUserRole === 'MD') {
  //       // Add your logic here
  //     }

  //     this.getAutorityListingData();
  //     this.getAllaseetListingData();
  //     this.assetAllocationData();


  //   });
  // }

  // Year 

  getpmsyearlist() {
    this.httpService.callGetService(this.config.getpmsyearlist + this.loggedInUserCompanyID).subscribe((data: any) => {
      this.pmsYears = formatYearRanges(data?.data?.yearRanges);

      const { fiscalStartYear, fiscalEndYear } = calculateFiscalYear(this.loggedInCompanyFiscalyear);

      const yearValue = `${fiscalStartYear}-${fiscalEndYear}`;
      this.setSelectedYear(yearValue);

      this.getAutorityListingData();
      this.getAllaseetListingData();
      this.assetAllocationData();
    });
  }
  setSelectedYear(yearValue: string): void {
    const selectedYearObj = this.pmsYears.find((ele: any) => ele.year === yearValue);
    if (selectedYearObj) {
      this.selectedYearForCompetency = selectedYearObj?.year;
      this.selectedYearForCompetency = selectedYearObj?.year;
          this.selectedYearForGraphOneHRAdmin = selectedYearObj?.year;
          this.selectedYearForGraphTwoHRAdmin = selectedYearObj?.year;
          this.selectedYearForGraphFifthHRAdmin = selectedYearObj?.year;
          this.selectedYearForGraphSix = selectedYearObj?.year;
          this.selectedYearForGraphNineHRAdmin = selectedYearObj?.year;
          this.selectedYearForGraphTenHRAdmin = selectedYearObj?.year;

      let test = selectedYearObj?.year.split('-');
      this.fromYear = test[0];
      this.toYear = test[1];
    }
  }
  getYearSetupForReimbursement() {

    this.getAutorityListingData();
    this.getAllaseetListingData()
  }


  // ----------------------------------------------------Autory --------------------------------------------------

  autorityListData: any = [];
  addAuthority(event: any) {
    const dialogConfig = new MatDialogConfig();

    dialogConfig.height = '70%';
    dialogConfig.width = '70%';   // Try setting width to a smaller value
    dialogConfig.panelClass = 'custom-dialog-container';  // Only set this class once
    dialogConfig.data = {
      operation: event ? "Update" : 'Add',
      selectedTab: this.selectedTypeTabName,
      selectedUserID: 345,
      year: this.selectedYearForCompetency,
      fiscal_year: this.loggedInCompanyFiscalyear,

      data: event
    };

    const dialogRef = this.dialog.open(AddAuthorityComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(result => {
      this.getAutorityListingData();
    });
  }
  allocatingDepaabaleheader = [
    { label: 'Allocating Department', isMandatory: true, sortingName: 'assetDepartmentName' },
    { label: 'Employee Name', isMandatory: true, sortingName: 'employeeName' },
    { label: 'Action' },
  ]


  getAutorityListingData() {
    this.httpService.callGetService(`${this.config.listingAssetAuthority}/${this.loggedInUserCompanyID}/${this.loggedInCompanyFiscalyear}/${this.selectedYearForCompetency}`)
      .subscribe((elm: any) => {
        this.autorityListData = elm.data;


      })

  }
  deleteAuthority(assetAuthorityId: any) {


    const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
      disableClose: true,
      height: '25%',
      width: '30%',
      data: {
        msg: 'Do you really want to delete this Allocating Department?',
        btn1: 'Cancel',
        btn2: 'Delete',
        btn2BgColor: this.buttonColorName,
        showSuccessIcon: false,
        showSuccessMessage: false,
        showCloseIcon: false,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {

      if (result) {
        this.httpService.callDeleteService(`${this.config.deleteAssetAuthority}/${assetAuthorityId}`).subscribe(
          (data: any) => {
            if (data) {
              // Success popup
              const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
                disableClose: true,
                height: '25%',
                width: '30%',
                data: {
                  msg: data.message,
                  btn2: 'OK',
                  btn2BgColor: this.buttonColorName,
                  showSuccessIcon: true,
                  showSuccessMessage: false,
                  showCloseIcon: false
                }
              });

              // Handle the result of the dialog
              dialogRef.afterClosed().subscribe(() => {
                console.log("After Delete");

                this.getAllaseetListingData();
                this.getAutorityListingData();
              });
            }
          },
          (error: any) => {

            const errorDialogRef = this.dialog.open(ConfirmationPopupComponent, {
              disableClose: true,
              height: '25%',
              width: '30%',
              data: {
                msg: error.error.error || 'An error occurred while processing your request. Please try again.',
                btn2: 'OK',
                btn2BgColor: 'red', // Highlight error with red button color
                showSuccessIcon: false,
                showSuccessMessage: false,
                showCloseIcon: true
              }
            });

            errorDialogRef.afterClosed().subscribe(() => {
              // Optionally handle any action after closing the error dialog
              console.log('Error dialog closed');
            });
          }
        );

      }
    });

  }
  // ----------------------------------------------------Autory --------------------------------------------------


  // ----------------------------------------------------Asset --------------------------------------------------

  // Asset Management



  addNewAssetEmployee(event: any) {
    const dialogConfig = new MatDialogConfig();

    dialogConfig.height = '100%';
    dialogConfig.width = '200vw';   // Try setting width to a smaller value
    dialogConfig.panelClass = 'custom-dialog-container';  // Only set this class once
    dialogConfig.data = {
      operation: event ? "Update" : 'Add',
      selectedTab: this.selectedTypeTabName,
      selectedUserID: 345,
      year: this.selectedYearForCompetency,
      fiscal_year: this.loggedInCompanyFiscalyear,
      data: event,
      assetId: null
    };

    const dialogRef = this.dialog.open(NewAssetEmployeeComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(result => {

      console.log("enside Colse new Asset");
      this.assetAllocationData();
    });



  }
  AllAssetListingData: any = [];
  addAsset(event: any) {
    console.log("addAsset");

    const dialogConfig = new MatDialogConfig();

    dialogConfig.height = '70%';
    dialogConfig.width = '70%';   // Try setting width to a smaller value
    dialogConfig.panelClass = 'custom-dialog-container';  // Only set this class once
    dialogConfig.data = {
      operation: event ? "Update" : 'Add',
      selectedTab: this.selectedTypeTabName,
      selectedUserID: 345,
      year: this.selectedYearForCompetency,
      fiscal_year: this.loggedInCompanyFiscalyear,
      data: event,
      assetId: null
    };

    const dialogRef = this.dialog.open(AddAssetComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(result => {
      this.getAllaseetListingData();

    });



  }
  showAsset(event: any) {
    const dialogConfig = new MatDialogConfig();

    dialogConfig.height = '70%';
    dialogConfig.width = '260vw'; // Responsive width
    dialogConfig.panelClass = 'custom-dialog-container';
    dialogConfig.disableClose = false; // Allows closing the dialog by clicking outside
    dialogConfig.data = {
      operation: event ? "Update" : 'Add',
      selectedTab: this.selectedTypeTabName,
      selectedUserID: 345,
      year: this.selectedYearForCompetency,
      fiscal_year: this.loggedInCompanyFiscalyear,
      assetId: event
    };

    const dialogRef = this.dialog.open(AddAssetComponent, dialogConfig);

    dialogRef.afterClosed().subscribe(result => {
      console.log(result);

      this.getAllaseetListingData();
    });
  }
  onClickLogs(moduleName: any) {
    this.router.navigate(['/home/hrportal/asset-logs', { moduleName: moduleName, id: 0 }]);
  }


  assettabaleheader = [
    { label: 'Asset Name', isMandatory: true, sortingName: 'assetName' },
    { label: 'Band', isMandatory: true, sortingName: 'bands' },
    { label: 'Allocating Department', isMandatory: true, sortingName: 'authorityDepartment' },
    { label: 'Autority Name', isMandatory: true, sortingName: 'authorityName' },
    { label: 'Action' },
  ]

  getAllaseetListingData() {
    console.log("getAllaseetListingData");

    this.httpService.callGetService(`${this.config.getAssetListingAll}/${this.loggedInUserCompanyID}/${this.loggedInCompanyFiscalyear}/${this.selectedYearForCompetency}`)
      .subscribe((elm: any) => {
        this.AllAssetListingData = elm.data;
        console.log(elm);


      })

  }

  deleteAasset(assetId: any) {


    this.httpService.callDeleteService(`${this.config.deleteAsset}/${assetId}`).subscribe(
      (data: any) => {
        if (data) {
          // Success popup
          const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
            disableClose: true,
            height: '25%',
            width: '30%',
            data: {
              msg: data.message,
              btn2: 'OK',
              btn2BgColor: this.buttonColorName,
              showSuccessIcon: true,
              showSuccessMessage: false,
              showCloseIcon: false
            }
          });

          // Handle the result of the dialog
          dialogRef.afterClosed().subscribe(() => {

            this.getAllaseetListingData();
          });
        }
      },
      (error: any) => {

        const errorDialogRef = this.dialog.open(ConfirmationPopupComponent, {
          disableClose: true,
          height: '25%',
          width: '30%',
          data: {
            msg: error.error.error || 'An error occurred while processing your request. Please try again.',
            btn2: 'OK',
            btn2BgColor: 'red', // Highlight error with red button color
            showSuccessIcon: false,
            showSuccessMessage: false,
            showCloseIcon: true
          }
        });

        errorDialogRef.afterClosed().subscribe(() => {
          // Optionally handle any action after closing the error dialog
          console.log('Error dialog closed');
        });
      }
    );
  }
  findLogdinUserAsaAuthority: any = false;
  checkDataForAuthority() {
    console.log(this.AllAssetListingData);
    console.log(this.loggedInUserId);

    const filterEployeeId = this.AllAssetListingData.filter((record: any) => record.userId == this.loggedInUserId);
    console.log(filterEployeeId.length);

    if (filterEployeeId.length > 0) {
      this.findLogdinUserAsaAuthority = true;


    }

  }
  // ---------------------------------------------------- End Asset --------------------------------------------------



  onCheckIconView = false;
  isFormDisabled = false;
  onClickIndividualScoreEdit() {
    this.onCheckIconView = true;
    this.isFormDisabled = true;
  }
  getScoreToFinalConverterIndividual() {

    this.onCheckIconView = false;
    this.isFormDisabled = false;
  }

  sortOrder: { [key: string]: 'asc' | 'desc' } = {}; // Track sort order for each key
  onSortAssending(sortKey: any): void {


    // this.autorityListData.sort((a: any, b: any) => {
    //   if (a[sortKey] < b[sortKey]) return -1; // a comes before b
    //   if (a[sortKey] > b[sortKey]) return 1;  // a comes after b
    //   return 0; // a and b are equal
    // });
    this.sortOrder[sortKey] = this.sortOrder[sortKey] === 'asc' ? 'desc' : 'asc';

    this.autorityListData.sort((a: any, b: any) => {
      if (a[sortKey] > b[sortKey]) return this.sortOrder[sortKey] === 'asc' ? -1 : 1;
      if (a[sortKey] < b[sortKey]) return this.sortOrder[sortKey] === 'asc' ? 1 : -1;
      return 0;
    });
  }


  onSortDesending(sortKey: any): void {
    // console.log(sortKey);
    // this.autorityListData.sort((a: any, b: any) => {
    //   if (a[sortKey] > b[sortKey]) return -1;
    //   if (a[sortKey] < b[sortKey]) return 1;
    //   return 0;
    // });
    this.sortOrder[sortKey] = this.sortOrder[sortKey] === 'asc' ? 'desc' : 'asc';

    this.autorityListData.sort((a: any, b: any) => {
      if (a[sortKey] < b[sortKey]) return this.sortOrder[sortKey] === 'asc' ? -1 : 1;
      if (a[sortKey] > b[sortKey]) return this.sortOrder[sortKey] === 'asc' ? 1 : -1;
      return 0;
    });
  }

  onSortDesendingForasset(sortKey: any) {

    // this.AllAssetListingData.sort((a: any, b: any) => {
    //   if (a[sortKey] < b[sortKey]) return -1; // a comes before b
    //   if (a[sortKey] > b[sortKey]) return 1;  // a comes after b
    //   return 0; // a and b are equal
    // });
    this.sortOrder[sortKey] = this.sortOrder[sortKey] === 'asc' ? 'desc' : 'asc';

    this.AllAssetListingData.sort((a: any, b: any) => {
      if (a[sortKey] < b[sortKey]) return this.sortOrder[sortKey] === 'asc' ? -1 : 1;
      if (a[sortKey] > b[sortKey]) return this.sortOrder[sortKey] === 'asc' ? 1 : -1;
      return 0;
    });
  }
  onSortAssendingForAsset(sortKey: any) {
    // this.AllAssetListingData.sort((a: any, b: any) => {
    //   if (a[sortKey] > b[sortKey]) return -1;
    //   if (a[sortKey] < b[sortKey]) return 1;
    //   return 0;
    // });
    this.sortOrder[sortKey] = this.sortOrder[sortKey] === 'asc' ? 'desc' : 'asc';

    this.AllAssetListingData.sort((a: any, b: any) => {
      if (a[sortKey] > b[sortKey]) return this.sortOrder[sortKey] === 'asc' ? -1 : 1;
      if (a[sortKey] < b[sortKey]) return this.sortOrder[sortKey] === 'asc' ? 1 : -1;
      return 0;
    });
  }
  // Sort order state


  deleteEmployee(id: any) {

  }




  selectedAssetName = '';
  displayedColumns: string[] = ['assetName'];
  employeeColumns: string[] = ['name', 'email'];



  // ------------------------------------------------------- laptop Assign ---------------------------------------------------------------------------------

  //  Laptop Assign Module
  userAsset(event: any) {
    console.log(event);

    if (event != null && !event?.users.some((user: any) => user?.userId !== null)) {
      console.log('Ignored: No valid userId found in event.users');
      return; // Exit if the condition is not met
    }

    const dialogConfig = new MatDialogConfig();

    // Try setting width to a smaller value
    dialogConfig.panelClass = 'custom-dialog-container';  // Only set this class once
    dialogConfig.data = {
      operation: event ? "Update" : 'Add',
      selectedTab: this.selectedTypeTabName,
      selectedUserID: 345,
      year: this.selectedYearForCompetency,
      fiscal_year: this.loggedInCompanyFiscalyear,
      data: event
    };

    const dialogRef = this.dialog.open(UserAssetComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(result => {
      this.assetAllocationData();
    });
  }

  employeeAsset(event: any) {
    console.log(event);

    const dialogConfig = new MatDialogConfig();

    dialogConfig.height = '70%';
    dialogConfig.width = '80%';   // Try setting width to a smaller value
    dialogConfig.panelClass = 'custom-dialog-container';  // Only set this class once
    dialogConfig.data = {
      operation: event ? "Update" : 'Add',
      selectedTab: this.selectedTypeTabName,
      selectedUserID: 345,
      year: this.selectedYearForCompetency,
      fiscal_year: this.loggedInCompanyFiscalyear,
      data: event,
      authority: this.findLogdinUserAsaAuthority ? 'From Authority' : this.selectedTypeTabName == 'Asset' ? 'From Employee' : 'HR Admin'
    };

    const dialogRef = this.dialog.open(AssetEmployeeEditComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(result => {
      this.assetAllocationData();
    });
  }


  originalAssets: any[] = [];
  assetAllocationFromAuthority: any = [];
  assetAllocationlistForEmployee: any = [];
  assetAllocationData() {
    this.httpService.callGetService(`${this.config.assetAllocation}/${this.loggedInUserCompanyID}/${this.loggedInCompanyFiscalyear}/${this.selectedYearForCompetency}`)
      .subscribe((elm: any) => {
        console.log(elm);

        this.originalAssets = elm.data;
        this.assetAllocationFromAuthority = elm.data;
        this.assetAllocationlistForEmployee = elm.data;
        this.groupAssetsByName();
        this.getDateByAuthorityName();
        this.getDateByEmployeeName();

        // this.groupEmployees();
      })

  }
  assets: any = [];

  // Group assets by asset name and merge users
  groupAssetsByName() {
    // Create a map to hold the grouped assets
    const assetMap = new Map<string, any>();

    // Loop through the original assets and group by asset name
    for (const asset of this.originalAssets) {
      if (assetMap.has(asset.assetName)) {
        // If asset name already exists, merge the users
        const existingAsset = assetMap.get(asset.assetName);
        existingAsset.users.push({
          id: asset.id,
          assetName: asset.assetName,
          bands: asset.bands,
          band: asset.band,
          assetId: asset.assetId,
          userId: asset.userId,
          employeeName: asset.employeeName,
          employeeComment: asset.employeeComment,
          currentAssetDescription: asset.currentAssetDescription,
          authorityDepartmentComment: asset.authorityDepartmentComment,
          // Corrected property name
          assetRepairTime: asset.assetRepairTime,
          employeeAssetStatus: asset.employeeAssetStatus,
          employeeCommentDate: asset.employeeCommentDate,
          dateOfAllocation: asset.dateOfAllocation,
          allocatingAuthorityName: asset.authorityName,
          authorityDepartment: asset.authorityDepartment,
          authorityCommentDate: asset.authorityCommentDate
        });
      } else {
        // If asset name doesn't exist, add it to the map
        assetMap.set(asset.assetName, {
          assetName: asset.assetName,
          bands: asset.bands,
          band: asset.band,
          dateOfAllocation: asset.dateOfAllocation,
          allocatingAuthorityName: asset.authorityName,
          isExpand: false,
          users: [{
            id: asset.id,
            assetName: asset.assetName,
            bands: asset.bands,
            band: asset.band,
            userId: asset.userId,
            assetId: asset.assetId,
            employeeName: asset.employeeName,
            employeeComment: asset.employeeComment,
            currentAssetDescription: asset.currentAssetDescription,
            authorityDepartmentComment: asset.authorityDepartmentComment,
            // Corrected property name
            assetRepairTime: asset.assetRepairTime,
            employeeAssetStatus: asset.employeeAssetStatus,
            employeeCommentDate: asset.employeeCommentDate,
            dateOfAllocation: asset.dateOfAllocation,
            allocatingAuthorityName: asset.authorityName,
            authorityDepartment: asset.authorityDepartment,
            authorityCommentDate: asset.authorityCommentDate
          }]
        });
      }
    }

    // Convert the map to an array
    this.assets = Array.from(assetMap.values());
  }



  deleteasset(id: any) {
    // Open confirmation dialog
    const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
      disableClose: true,
      height: '25%',
      width: '30%',
      data: {
        msg: 'Are you sure you want to delete this asset?',
        btn1: 'No',
        btn2: 'Yes',
        btn1BgColor: this.buttonColorName, // Set button colors if needed
        btn2BgColor: this.buttonColorName,
        showSuccessIcon: false,
        showSuccessMessage: false,
        showCloseIcon: false
      }
    });

    // Handle user's response
    dialogRef.afterClosed().subscribe((result: any) => {
      console.log(result);

      if (result) {
        // User clicked "Yes"
        this.httpService
          .callDeleteService(`${this.config.deleteAssetFromEmployee}/${id}`)
          .subscribe((elm: any) => {
            console.log(elm);
            if (elm) {
              const successDialogRef = this.dialog.open(ConfirmationPopupComponent, {
                disableClose: true,
                height: '25%',
                width: '30%',
                data: {
                  msg: elm.message,
                  btn2: 'OK',
                  btn2BgColor: this.buttonColorName,
                  showSuccessIcon: true,
                  showSuccessMessage: false,
                  showCloseIcon: false
                }
              });
            }
            this.assetAllocationData(); // Refresh the data
          });
      } else {
        // User clicked "No"
        console.log('Delete action cancelled.');
      }
    });
  }

  //----------------------------------------------------------------------- Single Authority User----------------------------------------------------------------------------------------------

  // allocateAuthority(event: any) {
  //   console.log(event);

  //   const dialogConfig = new MatDialogConfig();

  //   dialogConfig.height = '70%';
  //   dialogConfig.width = '80%';   // Try setting width to a smaller value
  //   dialogConfig.panelClass = 'custom-dialog-container'; // Only set this class once
  //   dialogConfig.data = {
  //     operation: event ? "Update" : 'Add',
  //     selectedTab: this.selectedTypeTabName,
  //     selectedUserID: 345,
  //     year: this.selectedYearForCompetency,
  //     fiscal_year: this.loggedInCompanyFiscalyear,
  //     data: event
  //   };

  //   const dialogRef = this.dialog.open(AllocateAssetComponent, dialogConfig);
  //   dialogRef.afterClosed().subscribe(result => {
  //     this.assetAllocationData();
  //   });
  // }


  allocateAuthority(event: any) {
    if (event != null && !event?.users.some((user: any) => user?.userId !== null)) {
      console.log('Ignored: No valid userId found in event.users');
      return; // Exit if the condition is not met
    }

    const dialogConfig = new MatDialogConfig();

    // Set to full-screen size
    dialogConfig.height = '100%';
    dialogConfig.width = '100%';
    dialogConfig.panelClass = 'full-screen-dialog'; // Add a specific class for full-screen styles
    dialogConfig.data = {
      operation: event ? "Update" : "Add",
      selectedTab: this.selectedTypeTabName,
      selectedUserID: 345,
      year: this.selectedYearForCompetency,
      fiscal_year: this.loggedInCompanyFiscalyear,
      data: event
    };

    const dialogRef = this.dialog.open(AllocateAssetComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(result => {
      this.assetAllocationData();
    });
  }




  allocatingAsset: any = [];
  getDateByAuthorityName() {
    console.log(this.assetAllocationFromAuthority);
    console.log(this.loggedInUserName);

    this.assetAllocationFromAuthority = this.assetAllocationFromAuthority.filter((record: any) => record.authorityName == this.loggedInUserName);


    if (this.assetAllocationFromAuthority.length > 0) {
      this.findLogdinUserAsaAuthority = true;
      // this.checkDataForAuthority();
      this.httpService.checkAuthorityName = this.findLogdinUserAsaAuthority;
      console.log(this.httpService.checkAuthorityName);
    }

    const assetMap = new Map<string, any>();

    // Loop through the original assets and group by asset name
    for (const asset of this.assetAllocationFromAuthority) {
      if (assetMap.has(asset.assetName)) {
        // If asset name already exists, merge the users
        const existingAsset = assetMap.get(asset.assetName);
        existingAsset.users.push({
          id: asset.id,
          assetName: asset.assetName,
          bands: asset.bands,
          band: asset.band,
          assetId: asset.assetId,
          userId: asset.userId,
          employeeName: asset.employeeName,
          employeeComment: asset.employeeComment,
          currentAssetDescription: asset.currentAssetDescription,
          authorityDepartmentComment: asset.authorityDepartmentComment,
          // Corrected property name
          assetRepairTime: asset.assetRepairTime,
          employeeAssetStatus: asset.employeeAssetStatus,
          employeeCommentDate: asset.employeeCommentDate,
          dateOfAllocation: asset.dateOfAllocation,
          allocatingAuthorityName: asset.authorityName,
          authorityDepartment: asset.authorityDepartment,
          authorityCommentDate: asset.authorityCommentDate
        });
      } else {
        // If asset name doesn't exist, add it to the map
        assetMap.set(asset.assetName, {
          assetName: asset.assetName,
          bands: asset.bands,
          band: asset.band,
          dateOfAllocation: asset.dateOfAllocation,
          allocatingAuthorityName: asset.authorityName,
          isExpand: false,
          users: [{
            id: asset.id,
            assetName: asset.assetName,
            bands: asset.bands,
            band: asset.band,
            userId: asset.userId,
            assetId: asset.assetId,
            employeeName: asset.employeeName,
            employeeComment: asset.employeeComment,
            currentAssetDescription: asset.currentAssetDescription,
            authorityDepartmentComment: asset.authorityDepartmentComment,
            // Corrected property name
            assetRepairTime: asset.assetRepairTime,
            employeeAssetStatus: asset.employeeAssetStatus,
            employeeCommentDate: asset.employeeCommentDate,
            dateOfAllocation: asset.dateOfAllocation,
            allocatingAuthorityName: asset.authorityName,
            authorityDepartment: asset.authorityDepartment,
            authorityCommentDate: asset.authorityCommentDate
          }]
        });
      }
    }

    // Convert the map to an array
    this.allocatingAsset = Array.from(assetMap.values());

    console.log(this.allocatingAsset);

  }

  // ------------------------------------------------------------------------------My Asset -----------------------------------------------------------------------------------------------------
  allocatingAssetEmployee: any = [];

  allocatingEmployee: any = [];
  assetOptions = [
    "RECEIVED_ASSET",
    "REPAIR_ASSET",
    "RETURNING ASSET DUE TO EXIT",
    "RECEIVED AFTER REPAIR"
  ];
  updateAssetData(event: any) {

  }
  getDateByEmployeeName() {
    console.log(this.assetAllocationlistForEmployee);

    console.log(this.loggedInUserId);

    this.allocatingAssetEmployee = this.assetAllocationlistForEmployee.filter((record: any) => record.userId == this.loggedInUserId);
    console.log(this.allocatingAssetEmployee);

    const assetMap = new Map<string, any>();

    // Loop through the original assets and group by asset name
    for (const asset of this.allocatingAssetEmployee) {
      if (assetMap.has(asset.assetName)) {
        // If asset name already exists, merge the users
        const existingAsset = assetMap.get(asset.assetName);
        existingAsset.users.push({
          id: asset.id,
          assetName: asset.assetName,
          bands: asset.bands,
          band: asset.band,
          assetId: asset.assetId,
          userId: asset.userId,
          employeeName: asset.employeeName,
          employeeComment: asset.employeeComment,
          currentAssetDescription: asset.currentAssetDescription,
          authorityDepartmentComment: asset.authorityDepartmentComment,
          // Corrected property name
          assetRepairTime: asset.assetRepairTime,
          employeeAssetStatus: asset.employeeAssetStatus,
          employeeCommentDate: asset.employeeCommentDate,
          dateOfAllocation: asset.dateOfAllocation,
          allocatingAuthorityName: asset.authorityName,
          authorityDepartment: asset.authorityDepartment,
          authorityCommentDate: asset.authorityCommentDate
        });
      } else {
        // If asset name doesn't exist, add it to the map
        assetMap.set(asset.assetName, {
          assetName: asset.assetName,
          bands: asset.bands,
          band: asset.band,
          dateOfAllocation: asset.dateOfAllocation,
          allocatingAuthorityName: asset.authorityName,
          isExpand: false,
          id: asset.id,
          users: [{
            id: asset.id,
            assetName: asset.assetName,
            bands: asset.bands,
            band: asset.band,
            userId: asset.userId,
            assetId: asset.assetId,
            employeeName: asset.employeeName,
            employeeComment: asset.employeeComment,
            currentAssetDescription: asset.currentAssetDescription,
            authorityDepartmentComment: asset.authorityDepartmentComment,
            // Corrected property name
            assetRepairTime: asset.assetRepairTime,
            employeeAssetStatus: asset.employeeAssetStatus,
            employeeCommentDate: asset.employeeCommentDate,
            dateOfAllocation: asset.dateOfAllocation,
            allocatingAuthorityName: asset.authorityName,
            authorityDepartment: asset.authorityDepartment,
            authorityCommentDate: asset.authorityCommentDate
          }]
        });
      }
    }

    // Convert the map to an array
    this.allocatingEmployee = Array.from(assetMap.values());

    console.log(this.allocatingEmployee);

  }
  parentHeaders = [
    { key: 'assetName', label: 'Asset Name' },
    { key: 'bands', label: 'Band' },
    { key: 'allocatingAuthorityName', label: 'Authority Name' }
  ];
  parentHeadersForEmployee = [
    { key: 'assetName', label: 'Asset Name' },
    { key: 'band', label: 'Band' },
    { key: 'allocatingAuthorityName', label: 'Authority Name' }
  ];
  nestedHeaders = [
    { key: 'employeeName', label: 'Employee Name' },
    { key: 'band', label: 'Band' },
    { key: 'authorityDepartment', label: 'Authority Dept' },
    { key: 'allocatingAuthorityName', label: 'Authority Name' },
    { key: 'dateOfAllocation', label: 'Allocation Date' },
    { key: 'currentAssetDescription', label: 'Current Asset Description' },
    { key: 'employeeAssetStatus', label: 'Employee Status' },
    { key: 'employeeComment', label: 'Employee Comment' },
    { key: 'employeeCommentDate', label: 'Employee Comment Date' },
    { key: 'authorityDepartmentComment', label: 'HR ADMIN/Allocating Authority Comment' },
    { key: 'authorityCommentDate', label: 'Authority Comment Date' },
    { key: 'assetRepairTime', label: 'Asset Repair Time' },
    { key: '', label: 'Action' },
  ];

  nestedHeadersForEmployee = [
    { key: 'employeeName', label: 'Employee Name' },
    { key: 'band', label: 'Band' },
    { key: 'authorityDepartment', label: 'Authority Dept' },
    { key: 'allocatingAuthorityName', label: 'Authority Name' },
    { key: 'dateOfAllocation', label: 'Allocation Date' },
    { key: 'currentAssetDescription', label: 'Current Asset Description' },
    { key: 'employeeAssetStatus', label: 'Employee Status' },
    { key: 'employeeComment', label: 'Employee Comment' },
    { key: 'employeeCommentDate', label: 'Employee Comment Date' },
    { key: 'authorityDepartmentComment', label: 'HR ADMIN/Allocating Authority Comment' },
    { key: 'authorityCommentDate', label: 'Authority Comment Date' },
    { key: 'assetRepairTime', label: 'Asset Repair Time' },

  ];
  ngOnChanges() {
    console.log("hdfgj");

    // Re-filter assets if the data changes
  }
  filteredAssets: any = []
  searchTerm: string = '';
  filterAssets(searchTerm: string) {
    console.log(searchTerm);

    // If the search term is empty, reset to original assets
    if (searchTerm === '') {
      this.assetAllocationData(); // Reset the original data (or fetch data again)
      this.assets = [...this.assets]; // Restore assets to the original state
    } else {
      // Normalize the search term by removing any spaces and converting to lowercase
      const normalizedSearchTerm = searchTerm.trim().toLowerCase();

      // Filter the assets based on the normalized search term
      this.filteredAssets = this.assets.filter((asset: any) =>
        asset.users.some((user: any) =>
          // Search for asset name or employee name (case-insensitive)
          (user.assetName && user.assetName.toLowerCase().includes(normalizedSearchTerm)) ||
          (user.employeeName && user.employeeName.toLowerCase().includes(normalizedSearchTerm))
        )
      );

      this.assets = this.filteredAssets; // Update assets with the filtered data
    }

    console.log(this.assets); // Log the filtered assets array
  }
}

